export default {
	setBreadcrumb(context, payload) {
		context.commit('SET_BREADCRUMB', payload);
	}
};



// WEBPACK FOOTER //
// ./sources/components/breadcrumb/actions.js